import React, { Component } from 'react';
import Header from "../../Header"; 
import Body from "../../Body"; 
import Footer from "../../Footer";

class LayoutPage extends Component {
  render() {
    const {children} = this.props;
    return(
      <React.Fragment>
        <Header {...this.props}/>
          <div className="container text-center">
            {children}
          </div>
        {/*<Footer />*/}
      </React.Fragment>
    );
  }
}

export default LayoutPage;